import React from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../sidebar/Sidebar";
import Navbar from "../navbar/Navbar";
import "./NotFound.scss";

const Permission = () => {
  const navigate = useNavigate();

  const goBack = () => navigate(-1);
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <div className="not-found">
          <h2>Unauthorized</h2>
          <br />
          <p>You do not have access to the requested page.</p>
          <div className="flexGrow">
            <button onClick={goBack}>Go Back</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Permission;
